import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../services/seo/seo.service';
import {HssResponse} from '../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../services/rest-api/HssErrorResponse';
import {InfoApiService} from '../../../services/rest-api/info.api.service';

@Component({
  selector: 'app-research-committee',
  templateUrl: './dailyweather.component.html',
  styleUrls: ['./dailyweather.component.scss']
})
export class DailyweatherComponent implements OnInit {

  geoData: any;

  constructor(private seo: SeoService,
              private info: InfoApiService) { }

  ngOnInit(): void {
    this.getWeather();
    this.seo.setMeta('Today s Weather, Matara', 'Daily weather observation at weather station at University of Ruhuna');
  }

  getWeather(){
    this.info.getWeather().subscribe (
      (response: HssResponse<any>) => {
        this.geoData = response.body[0];
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }
}
